<template>
    <div>
        <ListPage
            ref="listPage"
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            @selection-change="handleSelectionChange"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="名称" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="优惠券类型" prop="search_type">
                    <el-select v-model="query.search_type" placeholder="请选择优惠券类型">
                        <el-option label="满减" value="1" />
                        <el-option label="无门槛" value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道" prop="qd">
                    <el-select v-model="query.qd" placeholder="请选择渠道">
                        <el-option value="jd" label="京东"></el-option>
                        <el-option value="taobao" label="淘宝"></el-option>
                        <el-option value="tmall" label="天猫"></el-option>
                        <el-option value="amazon" label="亚马逊"></el-option>
                        <el-option value="aliExpress" label="速卖通"></el-option>
                        <el-option value="shopify" label="Shopify"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('yhqgl_yhqlb_pldc') || permission('yhqgl_yhqlb_xz')">
                <el-button v-if="permission('yhqgl_yhqlb_pldc')" size="mini" type="primary" @click="handleExport"> 批量导出 </el-button>
                <el-button v-if="permission('yhqgl_yhqlb_xz')" size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="排序" align="center" prop="sort" width="100" />
                <el-table-column label="优惠券名称" align="center" prop="name" />
                <el-table-column label="优惠券类型" align="center" prop="type">
                    <template slot-scope="{ row }">
                        {{ { 1: "满减", 2: "无门槛" }[row.type] }}
                    </template>
                </el-table-column>
                <el-table-column label="已领取数量" align="center" prop="cuser_count" />
                <el-table-column label="有效期" align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }"> {{ row.validity_start_date }} - {{ row.validity_end_date }} </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="create_time" width="180" />
                <el-table-column
                    v-if="
                        permission('yhqgl_yhqlb_lqxq') || permission('yhqgl_yhqlb_bj') || permission('yhqgl_yhqlb_sc') || permission('yhqgl_yhqlb_sj')
                    "
                    label="操作"
                    align="center"
                    width="180"
                >
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('yhqgl_yhqlb_lqxq')" size="mini" type="text" @click="handleDetail(row)"> 领取详情 </el-button>
                        <el-button v-if="permission('yhqgl_yhqlb_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('yhqgl_yhqlb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                        <el-button v-if="permission('yhqgl_yhqlb_sj')" size="mini" type="text" @click="handleData(row)"> 数据 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <DataVue ref="data"></DataVue>
    </div>
</template>

<script>
import DataVue from "./data.vue";
import { list, del } from "@/api/coupon/list";
import listMixin from "@/mixins/list";
import { downloadFileByUrl } from "@/jslibs/utils";

export default {
    components: { DataVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                search_type: "",
                qd: "",
            },
            module: "优惠券",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "优惠券列表.xlsx";
            const { search_keyword, search_type } = this.query;
            const uuids = this.picks.map((x) => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL + `/v1/cms/Coupon?export=1&search_keyword=${search_keyword}&search_type=${search_type}&uuids=${uuids}`,
                filename
            );
        },
        handleAdd() {
            this.$router.push({ path: "/coupon/list/form" });
        },
        handleDetail(row) {
            this.$router.push({ path: "/coupon/list/detail", query: { cuuid: row.cuuid } });
        },
        handleEdit(row) {
            this.$router.push({ path: "/coupon/list/form", query: { cuuid: row.cuuid } });
        },
        handleData(row) {
            this.$refs.data.open(row);
        },
    },
};
</script>
